module.exports = {
  "rain-item": {
    "position": "absolute",
    "opacity": 0
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-2e92c6ea!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-lottery-rain/rain-item.vue
// module id = 457
// module chunks = 0 1